import React, { FC, useEffect, useRef, useState } from 'react'
import NoSSR from 'react-no-ssr'

import { random } from 'lodash'
import styled from 'styled-components'
import { cloudinary } from '@constants'
import { connect } from 'react-redux'
import { Container, TextLink, Row, Col, SharingButton, VideoPlayer, Icon } from '@mch-group/uikit-components'
import useOnScreen from '@hooks/useOnScreen'
import useTabActive from '@hooks/useTabActive'
import CustomLinkTag from '../CustomLinkTag'
import Text from '../Text'
import cssClasses from '../../constants/cssClasses'
import LazyImage from '../Image'

const mID = 'rm-promotional'
const cloudinaryName = getEnvConfig.fe.cloudinary.name

const RmPromotional: FC<IRmPromotional> = (props) => {
  const ref = useRef<HTMLDivElement>(null)
  const isVisible = useOnScreen(ref, '500px')
  const isTabActive = useTabActive()
  const [isVideoDownloadTriggered, setIsVideoDownloadTriggered] = useState(false)
  // Stopping the video depending on scroll and tab.
  // Works with multiple instances of the Banner Component (each will start/stop accordingly)
  useEffect(() => {
    const videoPlayer: any = ref.current?.querySelector('.rm-promotional video')
    if (videoPlayer) {
      const playPromise = videoPlayer.play()
      if (playPromise !== undefined && !isTabActive) {
        playPromise
          .then(() => {
            // Automatic playback started!
            // Show playing UI.
            // We can now safely pause video...
            videoPlayer.pause()
          })
          .catch(() => {
            // Auto-play was prevented
            // Show paused UI.
          })
      }
    }
  }, [isVisible, isTabActive, props.id])

  useEffect(() => {
    if (isVisible && isTabActive) {
      setIsVideoDownloadTriggered(true)
    }
  }, [isTabActive, isVisible, isVideoDownloadTriggered])

  const createCleanImagesArray = () => {
    const newArray = []
    Array.from({ length: 4 }, (c, i) => {
      if (props[`promotional_grp1_img_${i}`]) {
        //@ts-ignore
        newArray.push(props[`promotional_grp1_img_${i}`])
      }
      return i
    })
    return newArray
  }
  const cleanImagesArray = createCleanImagesArray()

  const appendSpacingClass = () => {
    let field: any = null
    if (cleanImagesArray.length === 0) {
      if (props.promotional_grp1video_header_url) {
        field = 'video'
      } else if (props.promotional_grp1_title && !props.promotional_grp1_label) {
        field = 'title'
      } else if (props.promotional_grp1_label) {
        field = 'label'
      } else if (props.promotional_grp1_author_name && !props.promotional_grp1_title && !props.promotional_grp1_label) {
        field = 'author'
      } else if (
        props.promotional_grp1_body &&
        !props.promotional_grp1_title &&
        !props.promotional_grp1_subtitle &&
        !props.promotional_grp1_author_name &&
        !props.promotional_grp1_label
      ) {
        field = 'description'
      } else if (
        props.promotional_grp1_subtitle &&
        !props.promotional_grp1_title &&
        !props.promotional_grp1_author_name &&
        !props.promotional_grp1_label
      ) {
        field = 'subtitle'
      }
    }
    return (field && `${mID}--spacing-${field}`) || ''
  }

  const appendIsOnlyImage = () => {
    let isOnlyImage: any = null
    if (cleanImagesArray.length > 0) {
      if (
        !props.promotional_grp1_body &&
        !props.promotional_grp1_title &&
        !props.promotional_grp1_subtitle &&
        !props.promotional_grp1_author_name &&
        !props.promotional_grp1_label
      ) {
        isOnlyImage = true
      }
    }
    return (isOnlyImage && `${mID}--only-image`) || ''
  }

  const randomImage = cleanImagesArray[random(0, cleanImagesArray.length - 1)]
  const spaceClass = appendSpacingClass()
  const isOnlyImage = appendIsOnlyImage()

  const { promotional_grp1_author_name: author, promotional_grp1_title: title } = props
  return (
    <div className={`${props.className} ${cssClasses.CMS_MODULE} ${isOnlyImage}`}>
      <div className={`${mID} ${spaceClass}`} ref={ref}>
        {cleanImagesArray.length > 0 && (
          <CustomLinkTag url={props.promotional_grp1_cta_href}>
            {cleanImagesArray.length > 0 && <ModuleImage src={randomImage} author={author} title={title} />}
          </CustomLinkTag>
        )}
        {cleanImagesArray.length <= 0 && props.promotional_grp1video_header_url && (
          <VideoPlayer
            playing
            loop
            muted
            // onReady={() => setIsVideoButStillLoading(false)}
            url={
              isVideoDownloadTriggered &&
              cloudinary.throughCloudfront(
                `https://res.cloudinary.com/${cloudinaryName}/video/upload/vc_h264/${props.promotional_grp1video_header_url}.m3u8`
              )
            }
          />
        )}
        <div className='body-Text'>
          <Container className='px-lg-8 px-md-7 px-sm-5 mt-lg-10 mt-sm-7 mt-xs-7 mt-md-8'>
            {(props.promotional_grp1_title ||
              props.promotional_grp1_subtitle ||
              props.promotional_grp1_label ||
              props.promotional_grp1_body) && (
              <Row>
                <Col lg={8} md={10} xl={7}>
                  <div>
                    {props.promotional_grp1_cta_href && props.promotional_grp1_label && (
                      <CustomLinkTag url={props.promotional_grp1_cta_href}>
                        {props.promotional_grp1_label && (
                          <h1 className='header-uppercase-2 pb-3'>{props.promotional_grp1_label}</h1>
                        )}
                      </CustomLinkTag>
                    )}
                    {(props.promotional_grp1_label ||
                      props.promotional_grp1_title ||
                      props.promotional_grp1_author_name ||
                      props.promotional_grp1_subtitle) && (
                      <>
                        <Row>
                          <Col lg={10} sm={10} md={10} xl={10} xxl={10} xs={10}>
                            <CustomLinkTag url={props.promotional_grp1_cta_href}>
                              {props.promotional_grp1_title && (
                                <h1 className='title h3'>{props.promotional_grp1_title}</h1>
                              )}
                            </CustomLinkTag>
                          </Col>
                          <Col lg={2} sm={2} md={2} xl={2} xxl={2} xs={2}>
                            {props.promotional_grp1_flag_sharing_option === 'true' && (
                              <NoSSR>
                                <div className='d-flex justify-content-end'>
                                  <SharingButton
                                    media={[
                                      'facebook',
                                      'whatsapp',
                                      'linkedin',
                                      'twitter',
                                      'weebo',
                                      'wechat',
                                      'mail',
                                      'link-default'
                                    ]}
                                    variant='outline'
                                  />
                                </div>
                              </NoSSR>
                            )}
                          </Col>
                        </Row>
                        {props.promotional_grp1_author_name && (
                          <CustomLinkTag url={props.promotional_grp1_author_link}>
                            <div className='mb-lg-9 mb-xs-7 mb-sm-7 mb-md-7 mt-0 text-medium text-dark author'>
                              {props.promotional_grp1_author_name}
                            </div>
                          </CustomLinkTag>
                        )}
                        <Col lg={10} sm={10} md={10} xl={10} xxl={10} xs={10}>
                          <CustomLinkTag url={props.promotional_grp1_cta_href}>
                            {props.promotional_grp1_subtitle && <h5>{props.promotional_grp1_subtitle}</h5>}
                          </CustomLinkTag>
                        </Col>
                      </>
                    )}

                    {props.promotional_grp1_cta_href && props.promotional_grp1_body && (
                      <CustomLinkTag url={props.promotional_grp1_cta_href}>
                        {props.promotional_grp1_body && (
                          <Text isHtml className='text-medium mb-6 mt-3' forwardedAs='div'>
                            {props.promotional_grp1_body}
                          </Text>
                        )}
                      </CustomLinkTag>
                    )}
                    {/* Only body, no link */}
                    {!props.promotional_grp1_cta_href && props.promotional_grp1_body && (
                      <Text isHtml className='text-medium mb-6 mt-3' forwardedAs='div'>
                        {props.promotional_grp1_body}
                      </Text>
                    )}
                    {props.promotional_grp1_cta_label && props.promotional_grp1_cta_href && (
                      //@ts-ignore
                      <TextLink
                        iconAlign='right'
                        href={props.promotional_grp1_cta_href}
                        linkRenderer={(href) => (
                          <CustomLinkTag url={href} className='btn btn-link'>
                            {props.promotional_grp1_cta_label}
                            <Icon name='chevron-right' />
                          </CustomLinkTag>
                        )}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </div>
    </div>
  )
}

interface IRmPromotional {
  promotional_grp1_title: string
  promotional_grp1_subtitle: string
  promotional_grp1_label: string
  promotional_grp1_body: string
  promotional_grp1_cta_label: string
  promotional_grp1_cta_href: string
  promotional_grp1_author_name: string
  promotional_grp1_author_link: string
  promotional_grp1_flag_sharing_option: string
  promotional_grp1video_header_url: string
  className: string
  domain: string
  url: string
  id: number
}

const RmPromotionalConnected = connect(({ shared }) => ({
  domain: shared.domain,
  url: shared.url
}))(RmPromotional)

const ModuleImage: FC<IModuleImage> = ({ src, title, author }) => (
  <div className={`${mID}__banner`}>
    {src && (
      <>
        <div className='tablet hidden mobile hidden'>
          <LazyImage
            publicId={src}
            crop='fill'
            aspect_ratio='21:9'
            alt={`${title} by ${author}`}
            responsive
            preload='lqip'
          />
        </div>
        <div className='mobile only tablet only'>
          <LazyImage
            publicId={src}
            crop='fill'
            aspect_ratio='1:1'
            alt={`${title} by ${author}`}
            responsive
            preload='lqip'
          />
        </div>
      </>
    )}
  </div>
)

interface IModuleImage {
  src: string
  title: string
  author: string
}

const StyledRmPromotional = styled(RmPromotionalConnected)`
  &__banner {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding: 0;

    > div {
      @media (min-width: ${global.uikitVars.breakpointXs}) and (max-width: ${global.uikitVars.breakpointMdMax}) {
        padding-bottom: 62.5%;
      }

      @media (min-width: 992px) {
        margin-bottom: 40px;
        padding-bottom: 28%;
      }
    }

    img {
      position: absolute;
      max-width: 100%;

      @media (max-width: 992px) {
        position: absolute;
        width: initial !important;
      }
    }
  }

  .${mID}__banner,
  img {
    margin-left: auto;
    margin-right: auto;
    height: auto;
    width: 100%;
  }

  .${mID}__hide {
    display: none;
  }

  .title {
    overflow: hidden;
    text-overflow: clip;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .body-Text {
    @media (min-width: ${global.uikitVars.breakpointXs}) and (max-width: ${global.uikitVars.breakpointXsMax}) {
      margin: 24px 16px 0 16px;
    }
  }

  .author {
    @media (min-width: ${global.uikitVars.breakpointXs}) and (max-width: ${global.uikitVars.breakpointXsMax}) {
      margin-bottom: 24px;
    }
  }
`

export default StyledRmPromotional
